import { StyleSheet } from "react-native";
import { Color, ThemeUtils } from "components/src/utils";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "space-between",
    backgroundColor: Color.SECONDARY_BG_COLOR,
  },

  topContainer: {
    flex: 1,
    marginHorizontal: ThemeUtils.COMMON_MARGIN_HORIZONTAL,
    alignContent: "center",
  },

  viewicon: {
    marginTop: ThemeUtils.relativeRealHeight(1.5),
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  buttonContainer: {
    marginHorizontal: ThemeUtils.COMMON_MARGIN_HORIZONTAL,
    marginBottom: ThemeUtils.COMMON_MARGIN_HORIZONTAL,
    flexDirection: "row",
  },
});
export { styles };
